<template>
    <UserLogins></UserLogins>
</template>
<script>
import UserLogins from "@/components/UserLogins";

export default {
  name: "OrgLogs",
  components: {
    UserLogins,
  },
  created() {},
  methods: {},
  data() {
    return {
      list: [],
      notify: {
        type: 0,
        message: "",
        errors: [],
      },
      loading: false,
      paging: { count: 10, page: 1, size: 10, keyword: "" },
      tab: null,
      userId: 0,
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/views/organization/OrgLogs.vue